@use "foundation/_colors.scss";
@use "foundation/_responsive.scss";

.email-input {
  max-width: 90vw;
  margin: 0 auto;
  height: 5em;
  display: flex;
  justify-content: center;

  input[type="email"] {
    border-radius: 2.5em 0 0 2.5em;
    border-width: 0;
    height: 100%;
    width: 15em;
    max-width: 70vw;
    padding-left: 1.5em;
    padding-right: 0.1em;
    color: colors.$primary-text-color;
  }

  .verify-button {
    // Default overlay, this should be overwritten in element style
    background-color: colors.$dark-overlay-color;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0 2.5em 2.5em 0;
    border-width: 0;
    height: 100%;
    width: 5em;
    font-size: inherit;
    cursor: pointer;

    .right-triangle,
    .right-triangle > svg {
      height: 1.4em;
    }
  }

  @include responsive.phone-and-up {
    font-size: 1.5em;
  }
  @include responsive.tablet-and-up {
    font-size: 2em;
  }
}

p.secure-connections {
  text-align: center;
  font-weight: 700;
  color: colors.$ifttt-next-alternate-brand-color;

  a.learn-more {
    color: colors.$ifttt-next-alternate-brand-color;
    text-decoration: underline;
  }

  .ifttt-logo {
    svg {
      width: 2.7em;
    }
  }

  @include responsive.phone-and-up {
    font-size: 1.55em;
    margin-bottom: 0;
  }
  @include responsive.tablet-and-up {
    font-size: 2.45em;
  }
}

.verify-service, .connect-cta {
  display: flex;
  justify-content: center;
  align-self: center;
  color: colors.$ifttt-next-alternate-brand-color;

  .big-button {
    display: flex;
    align-items: center;
    justify-content: center;
    // Default overlay, this should be overwritten in element style
    background-color: colors.$dark-overlay-color;
    border-radius: 50%;
    height: 240px;
    width: 240px;

    span {
      display: flex;
      font-size: 2em;
      font-weight: 700;
    }
  }

  .reason {
    width: 90%;
    font-size: 1.925em; //equivalent size from connection status on returning_user_flow
    font-weight: 700;
    text-align: center;
    margin: 0 auto;
  }

  .action-button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2.5em;
    // Default overlay, this should be overwritten in element style
    background-color: colors.$dark-overlay-color;
    height: 5em;
    min-width: 15em;
    font-weight: 700;
    padding: 0 1.5em;

    // Don't follow size from reason content.
    max-width: fit-content;
    margin: 0 auto;
    margin-top: 3em;

    span {
      font-size: 1.3em;
    }

    @include responsive.phone-and-up {
      font-size: 1.5em;
    }
    @include responsive.tablet-and-up {
      font-size: 2em;
      margin-top: 1em;
    }
  }

  @include responsive.phone {
    font-size: 14.4px;
  }
}

.connect-cta {
  align-self: flex-end;
  margin-bottom: 15vh;

  .complete {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: colors.$light-overlay-color solid 8px;
    padding: 17%;
    height: 16vh;
    width: 16vh;
  }
  .check {
    svg {
      height: 7vh;
    }
  }

  .vertical-center {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      font-size: 1.5em;
      font-weight: 700;
    }
  }
}
